import { storeRef } from "@/components/providers/StoreProvider"
import { parseJson } from "../safeParse/parseJson"
import dayjs from "dayjs"

export const handleChooseTour = ({
  callback
}: {
  callback?: () => void
}) => {
  const tourState = storeRef.current?.getState().tour
  const bookingTour = parseJson(localStorage.getItem("booking_tour")) || {}

  localStorage.setItem("tour", JSON.stringify({
    ...tourState?.tour_details.data,
    departureSchedule: (tourState?.tour_details?.data?.departureSchedule || [])
      ?.filter(d => d.id === tourState?.inputTour.selectedDepartureSchedule)
  }))

  localStorage.setItem("booking_tour", JSON.stringify({
    ...bookingTour,
    number_of_passengers: {
      ...tourState?.inputTour,
      selectedDepartureSchedule: undefined
    }
  }))

  localStorage.setItem('current_time_session', `${dayjs().toString()}`)

  callback && callback()
}